import React, { Component } from "react";

import "./dashboard.css";
import NonPassiveTouchTarget from "./../../utils/NonPassiveTouchTarget";

import { CONSTANTS } from "../../utils/constant";

import cx from "classnames";
import { createBrowserHistory as createHistory } from "history";
import { Redirect, Link } from "react-router-dom";
import TouchCarousel, { clamp } from "react-touch-carousel";
import touchWithMouseHOC from "react-touch-carousel/lib/touchWithMouseHOC";

const { TOOLS } = CONSTANTS;
const { API } = CONSTANTS;

const query = window.location.search.slice(1);
const enableLoop = /\bloop\b/.test(query);
const enableAutoplay = /\bautoplay\b/.test(query);

const cardSize = 200;
const cardPadCount = enableLoop ? 3 : 0;
const carouselWidth = clamp(window.innerWidth, 0, 960);
const history: History = createHistory();

let activeSurveyCountGlobal = 0;
let activeSurveysGlobal = [];
function log(text, obj = "") {
  console.log(text, obj);
}

function CarouselContainer(props) {
  const {
    cursor,
    carouselState: { active, dragging },
    ...rest
  } = props;
  let current = -Math.round(cursor) % activeSurveyCountGlobal;
  while (current < 0) {
    current += activeSurveyCountGlobal;
  }
  // Put current card at center
  const { innerWidth: width, innerHeight: height } = window;
  let translateX = 0;
  if (width < 0) {
    translateX =
      (cursor - cardPadCount) * cardSize +
      (carouselWidth - cardSize - cardSize) / 2;
  } else {
    translateX = 0;
  }
  return (
    <NonPassiveTouchTarget
      className={cx("carousel-container", {
        "is-active": active,
        "is-dragging": dragging,
      })}
    >
      <NonPassiveTouchTarget
        className="carousel-track"
        style={{ transform: `translate3d(${translateX}px, 0, 0)` }}
        {...rest}
      />

      <div className="carousel-pagination-wrapper">
        <ol className="carousel-pagination">
          {activeSurveysGlobal.map((_, index) => (
            <li key={index} className={current === index ? "current" : ""} />
          ))}
        </ol>
      </div>
    </NonPassiveTouchTarget>
  );
}
const Container = touchWithMouseHOC(CarouselContainer);

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      activeSurveys: [],
      completedSurveys: [],
      userFullName: "",
      activeSurveyCount: 0,
      completedSurveyCount: 0,
      userPhoto: "",
      userEmail: "",
      userMob: "",
      userRole: "",
      userUniq: "",
      session_Uniq: "",
      clickedSurvey: "",
      logoutImage :'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pg0KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE5LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPg0KPHN2ZyB2ZXJzaW9uPSIxLjEiIGlkPSJMYXllcl8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNTA1LjY2NCwyNDMuNzM5bC01NC43ODMtMzguNjIyYy05LjkyNi02Ljk5Ny0yMy42NDUsMC4xMjgtMjMuNjQ1LDEyLjI2djIzLjYyMkgxNjQuMTk2DQoJCQljLTguMjg0LDAtMTUuMDAxLDYuNzE2LTE1LjAwMSwxNS4wMDFTMTU1LjkxMiwyNzEsMTY0LjE5NiwyNzFoMjYzLjAzOHYyMy42MjFjMCwxMi4yMTIsMTMuNzkyLDE5LjIwNCwyMy42NDQsMTIuMjZsNTQuNzgzLTM4LjYyMg0KCQkJQzUxNC4wMjcsMjYyLjM2NSw1MTQuMTk2LDI0OS43NjcsNTA1LjY2NCwyNDMuNzM5eiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KCTxnPg0KCQk8cGF0aCBkPSJNNDMwLjQ3MSwzNTIuMzE3Yy03LjE2OS00LjE0Ni0xNi4zNDctMS42OTgtMjAuNDk2LDUuNDc0Yy0zNS4yMzYsNjAuOTE2LTEwMS4xMDMsMTAxLjgxMS0xNzYuMzcyLDEwMS44MTENCgkJCWMtMTEyLjI2NiwwLTIwMy42MDItOTEuMzM2LTIwMy42MDItMjAzLjYwMlMxMjEuMzM3LDUyLjM5OCwyMzMuNjAzLDUyLjM5OGM3NS4zMTksMCwxNDEuMTU2LDQwLjkzMywxNzYuMzcxLDEwMS44MDkNCgkJCWM0LjE0OCw3LjE3MiwxMy4zMjgsOS42MTksMjAuNDk2LDUuNDc0YzcuMTcxLTQuMTQ4LDkuNjIxLTEzLjMyNSw1LjQ3NC0yMC40OTZDMzk1LjQxOCw2OS4xMjcsMzE5LjcyOSwyMi4zOTcsMjMzLjYwMywyMi4zOTcNCgkJCUMxMDQuNDksMjIuMzk3LDAsMTI2Ljg3NiwwLDI1NmMwLDEyOS4xMTMsMTA0LjQ3OSwyMzMuNjAzLDIzMy42MDMsMjMzLjYwM2M4Ni4xNjMsMCwxNjEuODMzLTQ2Ljc2MywyMDIuMzQyLTExNi43OQ0KCQkJQzQ0MC4wOTIsMzY1LjY0Miw0MzcuNjQyLDM1Ni40NjYsNDMwLjQ3MSwzNTIuMzE3eiIvPg0KCTwvZz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjxnPg0KPC9nPg0KPGc+DQo8L2c+DQo8Zz4NCjwvZz4NCjwvc3ZnPg0K'
    };
    this.getDashboardDetails = this.getDashboardDetails.bind(this);
    this.handleLoginResponse = this.handleLoginResponse.bind(this);
    this.setupUserDetails = this.setupUserDetails.bind(this);
    this.renderCard = this.renderCard.bind(this);
    this.startSurvey = this.startSurvey.bind(this);
    this.logout = this.logout.bind(this);
  }
  logout(){
    localStorage.clear();
    this.props.history.push("/login");
  }
  startSurvey(index, item) {
    this.setState(
      {
        // redirect: true,
        clickedSurvey: item,
      },
      () => {
        this.props.history.push("/survey", {
          id: this.state.clickedSurvey,
          surveys: this.state.activeSurveys,
        });
      }
    );
  }

  renderCard(index, modIndex) {
    const item = this.state.activeSurveys[modIndex];
    return (
      <div
        key={index}
        className="carousel-card"
        onClick={() => {
          this.startSurvey(modIndex, this.state.activeSurveys[modIndex]);
        }}
      >
        <div
          className="carousel-card-inner"
          style={{ backgroundColor: item?.background }}
        >
          {/* <div className='carousel-title'>{item.title}</div> */}
          <h2 className="survey-stat">{item?.surveyStat}</h2>
          <div className="carousel-text">{item?.surName}</div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (localStorage?.getItem("Viswas@React_app")) {
      this.getDashboardDetails();
      this.setupUserDetails();
    } else {
      this.props.history.push("/login");
    }
  }
  setupUserDetails() {
    const userLocalStorageDetails = JSON.parse(
      localStorage.getItem("Viswas@React_app")
    );
    this.setState({
      userFullName: userLocalStorageDetails.userFullName,
      userPhoto: userLocalStorageDetails.userPhoto
        ? userLocalStorageDetails.userPhoto
        : "data:image/png;base64,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",
      userEmail: userLocalStorageDetails.userEmail,
      userMob: userLocalStorageDetails.userMob,
      userRole: userLocalStorageDetails.userRole,
      userUniq: userLocalStorageDetails.userUniq,
      session_Uniq: userLocalStorageDetails.session_Uniq,
    });
  }

  getDashboardDetails() {
    const _this = this;
    const url = TOOLS.getUrl(API.user.dashboard);
    TOOLS.get(
      url,
      JSON.parse(localStorage.getItem("Viswas@React_app")).session_Token
    )
      .then(function (responseObj) {
        return responseObj.json();
      })
      .then(function (response) {
        console.log("Response to Set Play@At_ADMIN", response);
        _this.handleLoginResponse(response);
      });
  }
  handleLoginResponse(response) {
    console.log(response);
    if (response.status === "Success") {
      activeSurveyCountGlobal = response.Data.activeSurveys.length;
      activeSurveysGlobal = response.Data.activeSurveys;
      const activeSurveys = response.Data.activeSurveys.map((survey) => {
        const currentSurvey = survey;
        currentSurvey.background = "#ffca18";
        currentSurvey.surveyStat = `(${currentSurvey.totalSamplesCount}/${currentSurvey.totalSuveyCount})`;
        currentSurvey.surveyper = "";
        const fromDateFormat = currentSurvey.startDate.replace(/-/g, "/");
        const endDateFormat = currentSurvey.endDate.replace(/-/g, "/");
        const fromDate = new Date(fromDateFormat);
        const endDate = new Date(endDateFormat);
        const diffTime = Math.abs(endDate - fromDate);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        currentSurvey.daysRemains = diffDays;
        return currentSurvey;
      });
      console.log(activeSurveys);
      this.setState({
        activeSurveys: activeSurveys,
        completedSurveys: response.Data.completedSurveys,
        activeSurveyCount: response.Data.activeSurveys.length,
        completedSurveyCount: response.Data.completedSurveys.length,
      });
    }
  }
  render() {
    // if (this.state.redirect) {
    //   return (
    //     <Redirect
    //       to={{
    //         pathname: '/survey',
    //         state: {
    //           id: this.state.clickedSurvey,
    //           surveys: this.state.activeSurveys,
    //         },
    //       }}
    //     />
    //   );
    // }
    return (
      <React.Fragment>
        <div className="logout-container">
          <img
            className="logout-image"
            onClick={this.logout}
            src="https://icon-library.com/images/dc3fceb69e.png"
          />
        </div>
        <div className="container-fluid">
          <div className="row" style={{ width: '100vw',overflowX:'hidden' }}>
            <div className="col container no-gutters p-0">
              <div className="container-head">
                {/* <div className="menu">
                        <p>Hello</p>
                    </div> */}
              </div>
              <div className="container-body">
                <div className="profile-picture">
                  <img src={this.state.userPhoto} />
                </div>
                <div className="name">
                  <p>{this.state?.userFullName}</p>
                </div>
                <div className="location">
                  <p>{this.state?.userRole}</p>
                </div>
                {/* <div className="bio">
                        <p>Jos-based UX/UI Designer working on all things graphics</p>
                    </div> */}
                <div className="stats">
                  <div className="followers">
                    <p>Active Surveys</p>
                    <h1>{this.state.activeSurveyCount}</h1>
                  </div>
                  <div className="following">
                    <p>Completed Surveys</p>
                    <h1>{this.state.completedSurveyCount}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row active-surveys-container">
            <div className="container">
              <TouchCarousel
                component={Container}
                cardSize={cardSize}
                cardCount={this.state.activeSurveys.length}
                cardPadCount={cardPadCount}
                loop={enableLoop}
                autoplay={enableAutoplay ? 2e3 : false}
                renderCard={this.renderCard}
                onRest={(index) => log(`rest at index ${index}`)}
                onDragStart={() => log('dragStart')}
                onDragEnd={() => log('dragEnd')}
                onDragCancel={() => log('dragCancel')}
              />
            </div>
          </div>
          <div className="row inactive-surveys-container">
            <div className="container"></div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Dashboard;
